console.log("PopClub 0.49.0");
console.log("The skin Story 36.0");
// Body Function
window.addEventListener("click", function(event5) {
	if (event5.target == document.getElementById("myModal3")) {
		document.getElementById("myModal3").style.display = "none";
		let buyWithCoinsSpinner3 = document.getElementById("pop-spinner3");
		buyWithCoinsSpinner3.classList.add("hidden");
		document.getElementById("pop-club-quick-buy3").disabled = false;
		document.body.classList.remove("popcoinShow");
		popPrices();
	}
	if (event5.target == document.getElementById("myModal2")) {
		document.getElementById("myModal2").style.display = "none";
		let buyWithCoinsSpinner2 = document.getElementById("pop-spinner2");
		buyWithCoinsSpinner2.classList.add("hidden");
		document.getElementById("pop-club-quick-buy2").disabled = false;
		document.body.classList.remove("popcoinShow");
		popPrices();
	}
});
// Cart Drawer Discount Coupon Create
function createPopDiscounttCart() {
	// Removing the Coupon Code
	document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
	// Enable Loader
	document.querySelector(".gokwik-checkout button").setAttribute("disabled", "");
	document.querySelectorAll(".gokwik-checkout button span").forEach((el) => {
		el.classList.add("hidden");
	});
	document.querySelector(".gokwik-checkout button div").style.display = "block";
	// Shopify Ajax Cart API
	fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((data) => {
		let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
		let price_len = data["items_subtotal_price"].toString().length - 2;
		let price = data["items_subtotal_price"].toString().slice(0, price_len) + "." + data["items_subtotal_price"].toString().slice(price_len);
		let variants = "";
		for (let data_var of data["items"]) {
			variants += data_var["variant_id"] + "-" + data_var["quantity"] + ",";
		}
		let parameters = "?cart=" + price + "&shop=" + Shopify.shop + "&key=" + key + "&variants=" + variants;
		if (document.querySelector(".pop_club_cart #buy-with-pop-coins").checked) {
			fetch("https://prodreplica.mypopcoins.com/api/get-coins-cart-discount" + parameters).then((response) => response.json()).then((data) => {
				if (data.success == true) {

                  const date = new Date();
                  date.setTime(date.getTime() + (60 * 60 * 1000));
                  const expires = '; expires=' + date.toUTCString();
                  document.cookie = `discount_code=${data.code}${expires}; path=/`;
				}
			});
		} else {
			document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
		}
		setTimeout(() => {
			// Removing Loader
			document.querySelector(".gokwik-checkout button").removeAttribute("disabled");
			document.querySelectorAll(".gokwik-checkout button span").forEach((el) => {
				el.classList.remove("hidden");
			});
			document.querySelector(".gokwik-checkout button div").style.display = "none";
		}, 2500);
	});
}

function quickPop() {
	fetch("https://prodreplica.mypopcoins.com/api/get-brand?shop=" + Shopify.shop).then((response) => response.json()).then((data) => {
		let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
		// var popupPdp = document.getElementById("pop-club-product-detail-modal");
		var popupPdp = document.querySelector(".modal--is-active #pop-club-product-detail-modal");
		// console.log('ashish1')
		if (popupPdp) {
			// console.log('ashish2')
			let price2 = popupPdp.getAttribute("price");
			console.log("ashish", price2);
			var priceValue2 = Math.floor(price2);
			if (priceValue2.toString().length > 2) {
				var modulePrice2 = priceValue2 % 100;
				var roundedPrice2 = priceValue2 - modulePrice2;
			} else {
				var roundedPrice2 = 0;
			}
			let issueCoins2 = Math.round((data.issuance / 100) * roundedPrice2);
			popHTML2 = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png' width='20' height='21'> </span> " + issueCoins2 + " on this product  </p>";
			popupPdp.innerHTML = "";
			popupPdp.innerHTML = popHTML2;
		}
	});
}

function popcoinPopup() {
	let queryString = window.location.search;
	if (queryString.includes("coins=true") || queryString.includes("coins=TRUE")) {
		fetch("https://prodreplica.mypopcoins.com/api/get-brand?shop=" + Shopify.shop).then((response) => response.json()).then((data) => {
			document.getElementById("pop-club-iframe-url").value = data.iframe_url;
			console.log("modal opned");
			let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
			openPopModal3(key);
		});
	}
}
popcoinPopup();

function popCheck() {
	let buyWithPop = document.getElementById("buy-with-pop-coins");
	if (buyWithPop) {
		buyWithPop.onclick = function() {
			checkedPopup();
		};
	}
}
// Refresh, Onload Function
function popPrices() {
	const PDP_coin_context = document.querySelector("#buy-with-pop-coins-disc-label");
	let PDPRegularPrice = document.querySelector('.price-item.price-item--regular');
	const PDP_pop = document.querySelector("#pop-club-product-detail");
	const PDPQty = document.querySelector(".product-form__quantity .quantity input.quantity__input");
	const PDP_coin_wrapper = document.querySelector(".PDP-disc-container");
	let variantPrice;
	if (PDPRegularPrice) {
	  variantPrice = PDPRegularPrice.getAttribute('price');
	  if (variantPrice && variantPrice.includes(",")) {
	    variantPrice = variantPrice.split(",").join("");
	  }
	  if (PDPQty){
        variantPrice = parseInt(variantPrice) * parseInt(PDPQty.value);
      }else{
        variantPrice = parseInt(variantPrice) * parseInt(1);
      }
	  if (PDP_pop) PDP_pop.setAttribute("price", variantPrice);
	}
	fetch("https://prodreplica.mypopcoins.com/api/get-brand?shop=" + Shopify.shop).then((response) => response.json()).then((data) => {
		//Set URL of iframe
		document.getElementById("pop-club-iframe-url").value = data.iframe_url;
		document.getElementById("pop-club-data-redeem").value = data.redeem;
		let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
		var name1 = "_shopify_s";
		var hiteshcokkies = document.cookie.match(new RegExp("(^| )" + name1 + "=([^;]+)"));
		if (key == "undefined" || key == undefined || key == "" || hiteshcokkies == null || hiteshcokkies == "") {
			// location.reload();
		}
		if (window.location.href.indexOf("/cart") != -1) {
			loading();
		}
		parameters = "?shop=" + Shopify.shop + "&key=" + key;
		fetch("https://prodreplica.mypopcoins.com/api/get-available-coins" + parameters).then((response) => response.json()).then((data2) => {
			loggedIn = data2.success;
			let dataRedeem = document.getElementById("pop-club-data-redeem").value;
			if (data2.avaiable == false) {
				const popClubBuyNow = document.getElementById("pop-club-quick-buy");
				popClubBuyNow.setAttribute("disabled", "true");
			}
			let checkpopup = document.getElementById("buy-with-pop-coins");
			if (data2.success == true) {
				if (checkpopup) {
					document.getElementById("buy-with-pop-coins").checked = true;
				}
				const buyNow = document.querySelectorAll("#flo-buy-now-btn");
				const pop_buynow = document.querySelectorAll("#pop-club-quick-buy");
				buyNow.forEach((buyNowBtn) => {
					if (buyNow) {
						buyNowBtn.style.display = "none";
						pop_buynow.forEach((popBuyNowBtn) => {
							popBuyNowBtn.style.display = "block";
						});
					}
				});
			}
			/* else {
			  if (checkpopup) {
			   document.getElementById("buy-with-pop-coins").checked = false;
			  }
			} */
			if (data2.success == true) {
				document.getElementById("pop-club-login-flag").value = "true";
				const lottie_wrap = document.querySelector(".cart_pop_checkbox");
				if (lottie_wrap) lottie_wrap.classList.add("lottie-end");
				if (window.location.href.indexOf("/products") == -1 /* eventDelay() */ );
			} else {
				document.getElementById("pop-club-login-flag").value = "false";
			}
            if (data2.success == true) {
              var popClubDiv = document.getElementsByClassName("pop-club-listing");
              let i;
              for (i = 0; i < popClubDiv.length; i++) {
                  let price = popClubDiv[i].getAttribute("price");
                  let redeemCoins = Math.round((dataRedeem / 100) * price);
                  if (redeemCoins > data2.coins && data2.success == true) {
                      redeemCoins = data2.coins;
                  }
                  if (redeemCoins == 0) {
                      let popHTML = "";
                      popClubDiv[i].innerHTML = popHTML;
                  }
                  if (redeemCoins > 0) {
                      let redeemPrice = Math.round(price - redeemCoins);
                      let popHTML = "<p>or Rs. " + redeemPrice + " + <span class='pop-img'><img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " + redeemCoins + "</p>";
                      popClubDiv[i].innerHTML = popHTML;
                  }
              }
            }
			var popClubProductDiv = document.querySelectorAll("#pop-club-product-detail");
			// var popClubProductBuySpan = document.getElementById("pop-club-quick-buy-span");
			document.getElementById("pop-club-data-redeem").value = data.redeem;
			document.getElementById("pop-club-data-coins").value = data2.coins;
			let length_pop = popClubProductDiv.length;
			if (length_pop > 0) {
				let price = popClubProductDiv[length_pop - 1].getAttribute("price");
				let redeemCoins = Math.round((data.redeem / 100) * price);
				document.getElementById("pop-club-redeem-price").value = redeemCoins;
				if (redeemCoins > data2.coins && data2.success == true) {
					redeemCoins = data2.coins;
					document.getElementById("pop-club-redeem-price").value = redeemCoins;
				}
				let redeemPrice = Math.round(price - redeemCoins);
				// popClubProductBuySpan.innerHTML = "BUY USING Rs. " + redeemPrice + " + <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " + redeemCoins;
				let PDP_init_price = document.querySelector("#pop-club-product-detail");
				var priceValue = Math.floor(parseInt(PDP_init_price.getAttribute("initial_price")));
				if (priceValue.toString().length > 2) {
					var modulePrice = priceValue % 100;
					var roundedPrice = priceValue - modulePrice;
				} else {
					var roundedPrice = 0;
				}
				let issueCoins = Math.round((data.issuance / 100) * roundedPrice);
				if (PDPQty) issueCoins = parseInt(issueCoins) * parseInt(PDPQty.value);
				if (issueCoins > 0) {
					popHTML = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " + issueCoins + " on this product</p>";
					let productIssuanceMsg = document.getElementById("product-issuance-msg");
					if (productIssuanceMsg) {
						popClubProductDiv[length_pop - 1].innerHTML = popHTML;
					} else {
						popClubProductDiv[length_pop - 1].insertAdjacentHTML("afterbegin", popHTML);
					}
				}
				//Stripe Dynamic
				if (data2.avaiable == true) {
					const popClubStripe = document.getElementById("pop-club-quick-buy-span-stripe");
					if (redeemCoins == 0) {
						let popHTMLStripe = '<div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' + redeemCoins + '</div>| Shop and Earn POPcoins<img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
						popClubStripe.innerHTML = popHTMLStripe;
					} else {
						console.log("dcoins", data2.coins)
						if (window.location.href.indexOf("/products") == -1 && window.location.href.indexOf("/collections") == -1) redeemCoins = data2.coins;
						let popHTMLStripe = '<span class="saaki_royal">The Skin Story Reward</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' + redeemCoins + '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
						popClubStripe.innerHTML = popHTMLStripe;
						const PDPCheckbox = document.querySelector("#buy-with-pop-coins-disc");
						if (PDPCheckbox) PDPCheckbox.checked = false;
						if (PDP_coin_context) PDP_coin_context.innerHTML = `Rs.${redeemCoins} | Save using POPcoins`;
						if (PDP_coin_wrapper) PDP_coin_wrapper.style.display = "block";
					}
				}
			} else {
				redeemCoins = data2.coins;
				if (data2.avaiable == true) {
					const popClubStripe = document.getElementById("pop-club-quick-buy-span-stripe");
					if (redeemCoins == 0) {
						let popHTMLStripe = '<div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' + redeemCoins + '</div>| Shop and Earn POPcoins<img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
						popClubStripe.innerHTML = popHTMLStripe;
					} else {
						let popHTMLStripe = '<span class="saaki_royal">The Skin Story Reward</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' + redeemCoins + '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
						popClubStripe.innerHTML = popHTMLStripe;
						const PDPCheckbox = document.querySelector("#buy-with-pop-coins-disc");
						if (PDPCheckbox) PDPCheckbox.checked = false;
						if (PDP_coin_context) PDP_coin_context.innerHTML = `Save Rs.${redeemCoins} using POPcoins`;
						if (PDP_coin_wrapper) PDP_coin_wrapper.style.display = "block";
					}
				}
			}
			subTotal(data, data2);
		});
	});
}
//Onloadpdp
// popPrices();
//End --- Pop Coins Pricing
if (window.location.href.indexOf("/cart") != -1) {
	function loading() {
		var popLoading = document.getElementById("buy-with-pop-coins-label");
		var popText = 'Calculating your total cart value';
		popLoading.innerHTML = popText;
	}
}
//Start --- Buy with Pop Coins
const popClubBuyNow = document.getElementById("pop-club-quick-buy");
if (popClubBuyNow) {
	popClubBuyNow.addEventListener("click", function(e) {
		this.setAttribute("disabled", "true");
		displayPopSpinner();
		createPopCheckout();
	});
}
//End --- Buy with Pop Coins
function displayPopSpinner() {
	let buyWithCoinsSpinner = document.getElementById("pop-spinner2");
	buyWithCoinsSpinner.classList.remove("hidden");
}

function removePopSpinner() {
	const popClubBuyNow = document.getElementById("pop-club-quick-buy");
	if (popClubBuyNow) {
		popClubBuyNow.removeAttribute("disabled");
	}
	const buyWithCoinsSpinner = document.getElementById("pop-spinner2");
	if (buyWithCoinsSpinner) {
		buyWithCoinsSpinner.classList.add("hidden");
	}
}

function openPopModal() {
	let modal = document.getElementById("myModal");
	modal.style.display = "block";
}

function closePopModal() {
	modal.style.display = "none";
}

function createPopCheckout() {
	let variantId = document.getElementById("pop-club-product-id");
	let quantity = document.getElementsByName("quantity");
	if (!quantity) quantity.value = 1;
	console.log(quantity.value)
	let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
	parameters = "?variant=" + variantId.value + "&shop=" + Shopify.shop + "&key=" + key + "&quantity=" + quantity[0].value;
	fetch("https://prodreplica.mypopcoins.com/api/get-coins" + parameters).then((response) => response.json()).then((data) => {
		// console.log(data);
		removePopSpinner();
		if (data.success == true) {
			window.location = data.url;
		} else if (data.success == false) {
			openPopModal3(key);
		}
	});
}

function createPopCheckoutCart() {
	fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((data) => {
		let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
		let price_len = data["items_subtotal_price"].toString().length - 2;
		let price = data["items_subtotal_price"].toString().slice(0, price_len) + "." + data["items_subtotal_price"].toString().slice(price_len);
		let variants = "";
		for (let data_var of data["items"]) {
			variants += data_var["variant_id"] + "-" + data_var["quantity"] + ",";
		}
		let parameters = "?cart=" + price + "&shop=" + Shopify.shop + "&key=" + key + "&variants=" + variants;
		fetch("https://prodreplica.mypopcoins.com/api/get-coins-cart" + parameters).then((response) => response.json()).then((data) => {
			if (data.success == true) {
				window.location = data.url;
			} else if (data.success == false) {
				openPopModal3(key);
			}
		});
	});
}

function checkedPopup() {
	let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
	if (document.getElementById("pop-club-login-flag").value == "true") {
		let checkpopup = document.getElementById("buy-with-pop-coins");
		if (checkpopup.checked == true) {
			// createPopCheckoutCart();
		}
	} else {
		let checkpopup = document.getElementById("buy-with-pop-coins");
		if (checkpopup.checked == true) {
			openPopModal3(key);
		}
	}
	subTotalSecond();
}
/* Cart discount */
function cartpopDisc(e) {
	const input = document.querySelector("#buy-with-pop-coins");
	if (input.checked) {
		e.preventDefault();
		createPopCheckoutCart();
	} else {
		handleFloCheckoutBtn();
	}
}

function subTotal(data, data2) {
	let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
	var name1 = "_shopify_s";
	let parameters = "?shop=" + Shopify.shop + "&key=" + key;
	var popClubProductDiv = document.querySelector(".pop_club_cart #buy-with-pop-coins-label");
	if (popClubProductDiv) {
		fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((cartData) => {
			let price_len = cartData["items_subtotal_price"].toString().length - 2;
			let price = cartData["items_subtotal_price"].toString().slice(0, price_len) + "." + cartData["items_subtotal_price"].toString().slice(price_len);
			let redeemCoins = Math.round((data.redeem / 100) * price);
			let redeemPrice = Math.round(price - redeemCoins);
			if (redeemCoins > data2.coins && data2.success == true) {
				redeemCoins = data2.coins;
			}
			if (data2.success == true) {
				let checkpopup = document.getElementById("buy-with-pop-coins");
				document.getElementById("buy-with-pop-coins").style.display = "inline-block";
				if (checkpopup.checked == true) {
					if (redeemCoins == 0) {
						document.querySelector("input#buy-with-pop-coins").style.display = "none";
						popHTML = "You have 0 POPcoins. Shop now & earn coins.";
						document.getElementById("buy-with-pop-coins").checked = false;
					} else {
						document.getElementById("buy-with-pop-coins").style.display = "inline-block";
						popHTML = "Rs. " + redeemCoins + " | Saved using POPcoins";
					}
				} else {
					if (redeemCoins == 0) {
						document.querySelector("input#buy-with-pop-coins").style.display = "none";
						popHTML = "You have 0 POPcoins. Shop now & earn coins.";
						document.getElementById("buy-with-pop-coins").checked = false;
					} else {
						document.getElementById("buy-with-pop-coins").style.display = "inline-block";
						popHTML = "Save Rs. " + redeemCoins + " using POPcoins";
					}
				}
			}
			if (document.getElementById("pop-club-login-flag").value == "false") {
				document.querySelector("input#buy-with-pop-coins").style.display = "none";
				popHTML = '<span onclick="cartOpenIframe()"><span class="underline">Click </span> & get upto 30% off using POPcoins</span>';
				document.getElementById("buy-with-pop-coins").checked = false;
			}
			popClubProductDiv.innerHTML = popHTML;
		});
	}
	subTotalSecond();
}

function subTotalSecond() {
	if (window.location.href.indexOf("/cart") != -1) {
		loading();
	}
	let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
	var name1 = "_shopify_s";
	var hiteshcokkies = document.cookie.match(new RegExp("(^| )" + name1 + "=([^;]+)"));
	let parameters = "?shop=" + Shopify.shop + "&key=" + key;
	var popClubProductDiv = document.getElementById("buy-with-pop-coins-label");
	if (popClubProductDiv) {
		fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((cartData) => {
			let priceLenght = cartData["items_subtotal_price"].toString().length - 2;
			let price = cartData["items_subtotal_price"].toString().slice(0, priceLenght) + "." + cartData["items_subtotal_price"].toString().slice(priceLenght);
			let dataRedeem = document.getElementById("pop-club-data-redeem").value;
			let dataCoins = document.getElementById("pop-club-data-coins").value;
			let redeemCoins = Math.round((dataRedeem / 100) * price);
			let redeemPrice = Math.round(price - redeemCoins);
			if (redeemCoins > dataCoins && document.getElementById("pop-club-login-flag").value == "true") {
				document.querySelector("#buy-with-pop-coins-label").style.textDecoration = "none";
				redeemCoins = dataCoins;
			}
			if (document.getElementById("pop-club-login-flag").value == "true") {
				document.getElementById("buy-with-pop-coins").style.display = "inline-block";
				let checkpopup = document.getElementById("buy-with-pop-coins");
				if (checkpopup.checked == true) {
					if (redeemCoins == 0) {
						popHTML = "You have 0 POPcoins. Shop now & earn coins.";
						document.getElementById("buy-with-pop-coins").checked = false;
						document.getElementById("buy-with-pop-coins").style.display = "none";
						let price = document.querySelector(".totals__subtotal-value").innerHTML;
						let price_value = "Rs." + " " + price.split(" ")[1];
						document.querySelector(".totals__subtotal-value").innerHTML = price_value;
					} else {
						const check_pop = document.querySelector("#buy-with-pop-coins");
						if (check_pop.checked) {
							popHTML = "Rs." + redeemCoins + " | Saved using POPcoins";
						} else {
							popHTML = "Save Rs." + redeemCoins + " using POPcoins";
						}
						let price = document.querySelector(".totals__subtotal-value").innerHTML;
						let price_value = "Rs." + " " + price.split(" ")[1];
						document.querySelector(".totals__subtotal-value").innerHTML = price_value;
					}
					paragraph = document.querySelector(".totals__subtotal-value");
					var paragraph3 = paragraph.textContent;
					paragraph1 = paragraph3.split(" ");
					var subtotel = paragraph1[1].replace(",", "");
					//console.log(subtotel);
					var main_value = price - redeemCoins;
					var main_value1 = parseFloat(main_value).toFixed(2);
					//console.log(main_value1);
					paragraph.innerText = paragraph1[0] + " " + main_value1;
					subtotel = price;
				} else {
					paragraph = document.querySelector(".totals__subtotal-value");
					var paragraph3 = paragraph.textContent;
					// console.log('ashish uncheck');
					paragraph1 = paragraph3.split(" ");
					// var subtotel=paragraph1[1].replace(',','');
					paragraph.innerText = paragraph1[0] + " " + price;
					// popHTML = "You've saved Rs. " +redeemCoins +" using POPcoins";
					if (redeemCoins == 0) {
						document.querySelector("#buy-with-pop-coins-label").style.textDecoration = "none";
						popHTML = "You have 0 POPcoins. Shop now & earn coins.";
						document.getElementById("buy-with-pop-coins").checked = false;
						document.getElementById("buy-with-pop-coins").style.display = "none";
						let price = document.querySelector(".totals__subtotal-value").innerHTML;
						let price_value = "Rs." + " " + price.split(" ")[1];
						document.querySelector(".totals__subtotal-value").innerHTML = price_value;
					} else {
						document.querySelector("#buy-with-pop-coins-label").style.textDecoration = "none";
						const check_pop = document.querySelector("#buy-with-pop-coins");
						if (check_pop.checked) {
							popHTML = "Rs." + redeemCoins + " | Saved using POPcoins";
						} else {
							popHTML = "Save Rs." + redeemCoins + " using POPcoins";
						}
						let price = document.querySelector(".totals__subtotal-value").innerHTML;
						let price_value = "Rs." + " " + price.split(" ")[1];
						document.querySelector(".totals__subtotal-value").innerHTML = price_value;
					}
					// popHTML = "You've saved Rs. " +redeemCoins +" using POPcoins";
				}
			}
			if (document.getElementById("pop-club-login-flag").value == "false") {
				document.getElementById("buy-with-pop-coins").style.display = "none";
				//popHTML = "Save " +redeemCoins +" with POPcoins";
				popHTML = '<span onclick="cartOpenIframe()"><span class="underline">Click </span>& get upto 30% off using POPcoins</span>';
				document.getElementById("buy-with-pop-coins").checked = false;
			}
			// console.log(popHTML);
			//  let popHTML = "You've saved Rs. " +redeemCoins +" using POPcoins" +"  - Rs. "+ redeemCoins;
			popClubProductDiv.innerHTML = popHTML;
		});
	}
}
const checkbox = document.querySelector(".pop_club_cart #buy-with-pop-coins");
if (checkbox) checkbox.addEventListener("change", (event) => {
	if (event.currentTarget.checked) {
		subTotalSecond();
	}
});

function create(el) {
	var d = document;
	var element = d.createElement(el);
	element.classList.add("manual-class");
	return element;
}

function cart_i_icon() {
	let key1 = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
	openPopModal3(key1);
	document.querySelector(".back-to-top").classList.remove("hidden");
}
// To Create POPcoin Earn Call out for Cart Drawer
function cartDatas(data) {
	// Shopify Ajax Cart API
	fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((cartData) => {
		// InsertAfter Function
		function insertAfter(newNode, existingNode) {
			return new Promise((res, rej) => {
				res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
			});
		}
		var i = 0;
		// Cart Drawer
		(async function() {
			setTimeout(() => {
				document.querySelectorAll(".CartItemWrapper .CartItem").forEach((item) => {
					let price_len = cartData["items"][i].price.toString().length - 2;
					let quantity = cartData["items"][i].quantity;
					let price = cartData["items"][i].price.toString().slice(0, price_len) + "." + cartData["items"][i].price.toString().slice(price_len);
					i++;
					var priceValue = Math.floor(price);
					if (priceValue.toString().length > 2) {
						var modulePrice = priceValue % 100;
						var roundedPrice = priceValue - modulePrice;
					} else {
						var roundedPrice = 0;
					}
					var issueCoins = Math.round(
						(data.issuance / 100) * roundedPrice * quantity);
					var newstring = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png' width='20' height='21'> </span> " + issueCoins + " on this product</p>";
					if (item.querySelector(".product-description .manual_class_cart__price_down") != null) {
						item.querySelectorAll(".product-description .manual_class_cart__price_down").forEach((old_item) => {
							old_item.remove();
						});
					}
					insertAfter(create("div"), item.querySelector(".product-description .discounts.list-unstyled")).then(() => {
						item.querySelector(".product-description .manual_class_cart__price_down").innerHTML = "";
						item.querySelector(".product-description .manual_class_cart__price_down").innerHTML = newstring;
					});
				});
			}, 2000);
		})();
		// Cart Page
		var j = 0;
		document.querySelectorAll(".cart-drawer .mini-cart__inner .mini-cart__main cart-items .cart__item").forEach((item) => {
			console.log("cart page testing");
			let price_len = cartData["items"][j].price.toString().length - 2;
			let quantity = cartData["items"][j].quantity;
			let price = cartData["items"][j].price.toString().slice(0, price_len) + "." + cartData["items"][i].price.toString().slice(price_len);
			j++;
			var priceValue = Math.floor(price);
			if (priceValue.toString().length > 2) {
				var modulePrice = priceValue % 100;
				var roundedPrice = priceValue - modulePrice;
			} else {
				var roundedPrice = 0;
			}
			var issueCoins = Math.round(
				(data.issuance / 100) * roundedPrice * quantity);
			var newstring = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " + issueCoins + " on this product</p>";
			if (item.querySelector(".product-description .manual_class_cart__price_down") != null) {
				item.querySelectorAll(".product-description .manual_class_cart__price_down").forEach((old_item) => {
					old_item.remove();
				});
			}
			insertAfter(create("div"), item.querySelector(".product-description .discounts.list-unstyled")).then(() => {
				item.querySelector(".product-description .manual_class_cart__price_down").innerHTML = "";
				item.querySelector(".product-description .manual_class_cart__price_down").innerHTML = newstring;
			});
		});
	});
	let pop_cart_div = document.querySelector(".pop_club_cart");
	if (pop_cart_div != null) {
		let innerHtml = document.querySelector("#buy-with-pop-coins-label").innerHTML;
		if (innerHtml == "Save Rs. 0 Using POPcoins") {
			console.log("FLV:DKF");
			document.querySelector("input#buy-with-pop-coins").style.display = "none";
		}
	}
}
/* Cart page earn coins */
function earnCall() {
	fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json()).then((cartData) => {
		fetch("https://prodreplica.mypopcoins.com/api/get-brand?shop=" + Shopify.shop).then((response) => response.json()).then((data) => {
			let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];

			function insertAfter(newNode, existingNode) {
				return new Promise((res, rej) => {
					res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
				});
			}
			var i = 0;
			(async function() {
				setTimeout(() => {
					document.querySelectorAll(".CartItemWrapper .CartItem").forEach((item) => {
						if (cartData["items"][i]) {
							let priceLenght = cartData["items"][i].final_price.toString().length - 2;
							let quantity = cartData["items"][i].quantity;
							let price = cartData["items"][i].final_price.toString().slice(0, priceLenght) + "." + cartData["items"][i].price.toString().slice(priceLenght);
							if (price == ".0") {
								let val = document.querySelectorAll(".CartItem__Price")[i].textContent.split(",").join("").split(" ")[1];
								price = val;
								i++;
							}
							var priceValue = Math.floor(price);
							if (priceValue.toString().length > 2) {
								var modulePrice = priceValue % 100;
								var roundedPrice = priceValue - modulePrice;
							} else {
								var roundedPrice = 0;
							}
							var issueCoins = Math.round(
								(data.issuance / 100) * roundedPrice * quantity);
							if (issueCoins > 0) {
								var newstring = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png' width='20' height='21'> </span> " + issueCoins + "</p>";
								if (item.querySelector(".CartItem__PriceList .manual-class") != null) {
									item.querySelectorAll(".manual-class").forEach((old_item) => {
										old_item.remove();
									});
								}
								const ex = item.querySelector(".CartItem__PriceList .CartItem__Price");
								if (ex) {
									insertAfter(create("div"), item.querySelector(".CartItem__PriceList .CartItem__Price")).then(() => {
										item.querySelector(".CartItem__PriceList .manual-class").innerHTML = newstring;
									});
									i++;
								}
							}
						}
					});
				}, 1000);
			})();
		});
	});
	const checkbox = document.querySelector("#buy-with-pop-coins");
	const popcoinsLabel = document.querySelector("#buy-with-pop-coins-label");
	if (checkbox) {
		checkbox.checked = true;
		subTotalSecond();
	}
	let popLoading = document.getElementById("buy-with-pop-coins-label");
	let popText = "Calculating your total cart value";
	popLoading.innerHTML = popText;
	subTotalSecond();
}

function checkout_input() {
	let pop_cart_div = document.querySelector(".pop_club_cart");
	if (pop_cart_div != null) {
		pop_cart_div.querySelector("#buy-with-pop-coins").addEventListener("click", () => {
			pop_cart_div.querySelector("#buy-with-pop-coins").setAttribute("disabled", "");
			fetch("https://prodreplica.mypopcoins.com/api/get-available-coins" + parameters).then((response) => response.json()).then((data) => {
				if (!data.success) {
					document.querySelector("body").classList.remove("overflow-hidden");
					document.querySelector("#BackToTop").classList.remove("hidden");
					let key1 = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
					openPopModal3(key1);
				} else {
					let subTotal = document.querySelector("#cart-drawer .mini-cart__footer .product-price.cart-subtotal-price").getAttribute("cart_val");
					let totalPrice = subTotal.replace("Rs.", "");
					let cartSubTotal = totalPrice.replace(",", "");
					let total_value = cartSubTotal;
					total_value = parseInt(total_value);
					let pop_disc = pop_cart_div.querySelector("#buy-with-pop-coins-label").innerHTML.split("|")[0];
					pop_disc = parseInt(pop_disc.replace("Rs.", "").replace("₹", "").replace(".", ""));
					let pop_checkout_checked = pop_cart_div.querySelector("#buy-with-pop-coins").checked;
					let price_pop_val, cart_pop_last_str;
					if (pop_checkout_checked) {
						cart_pop_last_str = "Saved Using POPcoins";
						price_pop_val = "Rs. " + (total_value - pop_disc) + ".00";
					} else {
						cart_pop_last_str = "Using POPcoins";
						price_pop_val = "Rs. " + total_value + ".00";
					}
					document.querySelector("#cart-drawer .mini-cart__footer .product-price.cart-subtotal-price").innerHTML = price_pop_val;
					pop_cart_div.querySelector("#buy-with-pop-coins-label").innerHTML = "Save Rs. " + pop_disc + " | " + cart_pop_last_str;
				}
				pop_cart_div.querySelector("#buy-with-pop-coins").removeAttribute("disabled");
				createPopDiscounttCart();
			});
		});
	}
}

function PDP_qtys() {
	setTimeout(() => {
		let PDPRegularPrice = document.querySelector(".product__info-wrapper span.price-item.price-item--regular");
		const PDP_pop = document.querySelector("#pop-club-product-detail");
		let variantPrice;
		if (PDPRegularPrice) {
			variantPrice = PDPRegularPrice.getAttribute('price');
			if (variantPrice && variantPrice.includes(",")) {
				variantPrice = variantPrice.split(",").join("");
			}
			if (PDP_pop) PDP_pop.setAttribute("price", variantPrice);
		}
		popPrices();
	}, 1000);
}
// PDP Buy Fix
function pdp_buy_now() {
	if (window.location.href.includes("/products") == true) {
		let pdp_pop_div = document.querySelector(".pdp_popcoin");
		// Buy Now Button
		let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
		let parameters = "?shop=" + Shopify.shop + "&key=" + key;
		fetch("https://prodreplica.mypopcoins.com/api/get-available-coins" + parameters).then((response) => response.json()).then((data) => {
			if (!data.success) {
				pdp_pop_div.classList.add("hidden");
			} else {
				pdp_pop_div.classList.remove("hidden");
				let coin_val = data.coins;
				let pdp_price = document.querySelector(".price__regular .price-item.price-item--regular").getAttribute("price");
				pdp_price = parseInt(pdp_price);
				let pdp_curr_pop_price = Math.min(Math.ceil((pdp_price * 30) / 100), coin_val);
				if (pdp_curr_pop_price == 0) {
					pdp_pop_div.classList.add("hidden");
				} else {
					pdp_pop_div.classList.remove("hidden");
				}
				let pdp_input_checked = pdp_pop_div.querySelector("#buy-with-pop-coins").checked;
				let pdp_pop_last_str;
				if (pdp_input_checked == true) {
					pdp_pop_last_str = "Saved Using POPcoins";
					let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
					let pdp_var_id = pdp_pop_div.querySelector("#buy-with-pop-coins").getAttribute("variant_id");
					let parameters = "?cart=" + pdp_curr_pop_price + "&shop=" + Shopify.shop + "&key=" + key + "&variants=" + pdp_var_id;
					fetch("https://prodreplica.mypopcoins.com/api/get-coins-cart-discount" + parameters).then((response) => response.json()).then((data) => {
						const date = new Date();
                        date.setTime(date.getTime() + (60 * 60 * 1000));
                        const expires = '; expires=' + date.toUTCString();
                        document.cookie = `discount_code=${data.code}${expires}; path=/`;
					});
				} else {
					pdp_pop_last_str = "Using POPcoins";
					document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
				}
				pdp_pop_div.querySelector("#buy-with-pop-coins-label").innerHTML = "Save Rs. " + pdp_curr_pop_price + " " + pdp_pop_last_str;
			}
		});
		pdp_pop_div.querySelector("#buy-with-pop-coins").addEventListener("click", function() {
			// Enable PDP Loader
			document.querySelector(".xpresslane-button #gokwik-buy-now div").style.display = "flex";
			document.querySelector(".xpresslane-button #gokwik-buy-now div").id = "btn-loader";
			document.querySelector(".xpresslane-button #gokwik-buy-now").setAttribute("disabled", "");
			let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
			let parameters = "?shop=" + Shopify.shop + "&key=" + key;
			fetch("https://prodreplica.mypopcoins.com/api/get-available-coins" + parameters).then((response) => response.json()).then((data) => {
				if (!data.success) {
					pdp_pop_div.classList.add("hidden");
				} else {
					pdp_pop_div.classList.remove("hidden");
					let coin_val = data.coins;
					let pdp_price = document.querySelector(".price__regular .price-item.price-item--regular").getAttribute("price");
					pdp_price = parseInt(pdp_price);
					let quantityValue = document.querySelector("quantity-input .quantity__input#Quantity-buy_buttons");
					let pdp_qty = 1;
					if (quantityValue != null) {
						let pdp_qty = parseInt(quantityValue).value;
					} else {
						let pdp_qty = 1;
					}
					let pdp_curr_pop_price = Math.min(Math.ceil((pdp_price * 30) / 100) * pdp_qty, coin_val);
					if (pdp_curr_pop_price == 0) {
						pdp_pop_div.classList.add("hidden");
					} else {
						pdp_pop_div.classList.remove("hidden");
					}
					let pdp_input_checked = pdp_pop_div.querySelector("#buy-with-pop-coins").checked;
					let pdp_pop_last_str;
					if (pdp_input_checked == true) {
						pdp_pop_last_str = "Saved Using POPcoins";
						let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
						let pdp_var_id = pdp_pop_div.querySelector("#buy-with-pop-coins").getAttribute("variant_id");
						let parameters = "?cart=" + pdp_price + "&shop=" + Shopify.shop + "&key=" + key + "&variants=" + pdp_var_id;
						fetch("https://prodreplica.mypopcoins.com/api/get-coins-cart-discount" + parameters).then((response) => response.json()).then((data) => {
							const date = new Date();
                            date.setTime(date.getTime() + (60 * 60 * 1000));
                            const expires = '; expires=' + date.toUTCString();
                            document.cookie = `discount_code=${data.code}${expires}; path=/`;
							// Applying Cookie
							setTimeout(() => {
								// Remove PDP Loader
								document.querySelector(".xpresslane-button #gokwik-buy-now div").style.display = "none";
								document.querySelector(".xpresslane-button #gokwik-buy-now div").id = "btn-loader";
								document.querySelector(".xpresslane-button #gokwik-buy-now").removeAttribute("disabled");
							}, 2500);
						});
					} else {
						pdp_pop_last_str = "Using POPcoins";
						document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
						// Remove PDP Loader
						document.querySelector(".xpresslane-button #gokwik-buy-now div").style.display = "none";
						document.querySelector(".xpresslane-button #gokwik-buy-now div").id = "btn-loader";
						document.querySelector(".xpresslane-button #gokwik-buy-now").removeAttribute("disabled");
					}
					pdp_pop_div.querySelector("#buy-with-pop-coins-label").innerHTML = "Save Rs. " + pdp_curr_pop_price + " " + pdp_pop_last_str;
				}
			});
		});
	}
}
// Cart and PDP Cookie Manage
function pop_pdp_disc_manage() {
	if (window.location.href.includes("/products") == true) {
		document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
		let pdp_pop = document.querySelector(".pdp_popcoin #buy-with-pop-coins");
		if (pdp_pop.checked == true) {
			pdp_pop.click();
		}
		let cart_pop_checked = document.querySelector(".pop_club_cart #buy-with-pop-coins");
		if (cart_pop_checked.checked == true) {
			cart_pop_checked.click();
		}
	}
}
// Opening the Modal
// function cartOpenIframe() {
// 	document.querySelector("#BackToTop").classList.remove("hidden");
// 	let key1 = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
// 	openPopModal3(key1);
// }
// PDP Quantity Change
function pdp_qty_fix() {
	document.querySelectorAll("quantity-input .quantity__input#Quantity-buy_buttons").forEach(function(el) {
		el.addEventListener("change", function() {
			let redeemCoins = parseInt(document.querySelector("#pop-club-data-coins").getAttribute("value"));
			let pdp_qty = parseInt(document.querySelector("quantity-input .quantity__input#Quantity-buy_buttons").value);
			let price = parseInt(document.querySelector("#pop-club-product-detail").getAttribute("price"));
			let pdp_max_coin = Math.min(Math.ceil(pdp_qty * parseInt(price) * 0.3), redeemCoins);
			let key = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
			let pop_earn_price = Math.floor((parseInt(price) * pdp_qty) / 100) * 5;
			let pop_pdp_msg = document.querySelector("#pop-club-product-detail #product-issuance-msg");
			pop_pdp_msg.innerHTML = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png' width='20' height='21'> </span> " + pop_earn_price + " on this product  </p>";
			let is_pop_login = document.querySelector("#pop-club-login-flag").getAttribute("value");
			if (is_pop_login == "true" && redeemCoins > 0) {
				let strip_new_str = '<span class="saaki_royal">BraavoKing Reward</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' + pdp_max_coin + '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
				document.querySelector("#pop-club-quick-buy-span-stripe").innerHTML = strip_new_str;
				document.querySelector(".pdp_popcoin #buy-with-pop-coins-label").innerHTML = "Save Rs. " + pdp_max_coin + " Using POPcoins";
				document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
				document.querySelector(".pdp_popcoin #buy-with-pop-coins").checked = false;
			} else {
				document.querySelector(".pdp_popcoin").classList.add("hidden");
			}
		});
	});
}

// function load_iframe() {
//   let keyvalue1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
//   if (window.location.href.indexOf('/products/') != -1) {
//     var redeemPrices = document.getElementById('pop-club-redeem-price').value;
//     let key = document.cookie
//       .split('; ')
//       .find((row) => row.startsWith('_shopify_s='))
//       ?.split('=')[1];
//     let redeemCoins = redeemPrices;
//     let iframeURL = document.getElementById('pop-club-iframe-url').value;
//     document.getElementById('popupiframe2').src = iframeURL + '?key=' + key + '&page=pdp&discount=' + redeemCoins;
//   } else {
//     let cartPage = '';
//     if (window.location.href.indexOf('/cart') != -1) {
//       cartPage = '&page=cart';
//     }
//     let iframeURL = document.getElementById('pop-club-iframe-url').value;
//     document.getElementById('popupiframe2').src = iframeURL + '?key=' + keyvalue1 + cartPage;
//   }
// }

// function nonCartIframe(){
//   let modal = document.getElementById('myModal3');
//   modal.style.display = 'block';
//   document.body.classList.add('popcoinShow');
// }

document.addEventListener("DOMContentLoaded", function() {
	popPrices();
	if (window.location.href.indexOf("/cart") != -1) {
		earnCall();
	}
	if (window.location.href.includes("/search?")) {
		popPrices();
	}
    // load_iframe();
});
document.addEventListener("load", () => {
	const popClubBuyNow = document.getElementById("pop-club-quick-buy");
	popClubBuyNow.setAttribute("disabled", "false");
})
function openLoadedIframe() {
	let modal = document.getElementById('myModal3');
	modal.style.display = 'block';
	document.body.classList.add('popcoinShow');
}
const body = document.querySelector("body");

function nonCartIframe() {
	if (document.querySelector("#popupiframe2").src.toString().includes('-cart') == false) {
		// preLoadIframe(true);
		openLoadedIframe();
	} else {
		preLoadIframe();
		openLoadedIframe();
	}
}

function cartOpenIframe() {
	if (document.querySelector("#popupiframe2").src.toString().includes('-cart') == true) {
		// preLoadIframe(true);
		openLoadedIframe();
	} else {
		preLoadIframe('-cart');
		openLoadedIframe();
	}
}

function loadIframe() {
	preLoadIframe();
	console.log('okay loaded');
}

/* preloading iframe using mousemove and touchstart functions */
function preLoadIframe(cartParam = '') {
	let keyvalue1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
	if (window.location.href.indexOf('/products/') != -1) {
		var redeemPrices = document.getElementById('pop-club-redeem-price').getAttribute('pop_test');
		let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
		let redeemCoins = redeemPrices;
		let iframeURL = document.getElementById('pop-club-iframe-url').getAttribute('pop_test');
		document.getElementById('popupiframe2').src = iframeURL + '&key=' + key + '&page=pdp&discount=' + redeemCoins + '&url=' + window.location.href + cartParam;
	} else {
		let cartPage = '';
		if (window.location.href.indexOf('/cart') != -1) {
			cartPage = '&page=cart';
		}
		let iframeURL = document.getElementById('pop-club-iframe-url').getAttribute('pop_test');
		document.getElementById('popupiframe2').src = iframeURL + '&key=' + keyvalue1 + cartPage + '&url=' + window.location.href + cartParam;
	}
	body.removeEventListener("mousemove", loadIframe);
	body.removeEventListener("touchstart", loadIframe);
}

// as soon as user start interacting with the browser we are loading our iframe
// we are doing this to improve performance
body.addEventListener("mousemove", loadIframe);
body.addEventListener("touchstart", loadIframe);